import React from "react";
import { BiExport } from "react-icons/bi";
import html2canvas from "html2canvas";
function DonwlodButton({  isLoading, children, type }) {

  const handleScreenshot = async () => {
    const element = document.querySelector(".main-content");
    if (element) {
      const canvas = await html2canvas(element);
      const imgData = canvas.toDataURL("image/png");
      const link = document.createElement("a");
      link.href = imgData;
      link.download = "screenshot.png";
      link.click();
    } else {
      console.error("Element with class 'main-content' not found.");
    }
  };
  return (
    <button
      type={type}
      className="download_btn mbot-btn-primary center-alignment text-dark-blue"
      onClick={handleScreenshot}
      disabled={isLoading}
      style={{
        border: "1px solid #C3D3E2",
      }}
    >
      <BiExport
        style={{
          color: "#0F3659",
          height: "16px",
          width: "16px",
        }}
      />
      Export
      {isLoading ? <span className="loader"></span> : children}
    </button>
  );
}

export default DonwlodButton;
